import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';
import { MnnItem } from '../../../models/mnn-item';
import { MnnResponse } from '../../../models/mnn-response';
import { NgxSpinnerService } from 'ngx-spinner';
import { LoggingService } from '../../../../../services/logging.service';

const apiServer = environment.apiServer;

@Component({
  selector: 'app-modal-mnn',
  templateUrl: './modal-mnn.component.html',
  styleUrls: ['./modal-mnn.component.sass']
})
export class ModalMnnComponent implements OnInit {
  http: HttpClient;

  dataMnn: Array<MnnItem>;
  sortColumnName: string = "isGrotex";
  sortColumnType: "asc" | "desc" = "asc";
  filterMnn: string = null;
  
  lastSortColumnName: string
  lastAuctionId: string

  spinner: NgxSpinnerService;

  constructor(private _http: HttpClient, private _spinner: NgxSpinnerService, private loggingService: LoggingService) {
    this.http = _http;
    this.spinner = _spinner;
  }

  ngOnInit() {
    $('#modalMnnComponent').on('show.bs.modal', function () {
      $('#modalAuctionDetail').css({'z-index': 1030});
    })

    $('#modalMnnComponent').on('hidden.bs.modal', function () {
      $('#modalAuctionDetail').css({'z-index': 1041});
    })
  }

  sort(colName: string){
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.ModalMnnComponent.sort', null, 'Sort started');
      
      this.sortColumnName = colName

      if (this.lastSortColumnName == this.sortColumnName) {
        if (this.sortColumnType == "asc") {
          this.sortColumnType = "desc"
        } else {
          this.sortColumnType = "asc"
        }
      } else {
        this.sortColumnType = "asc"
      }
      this.loadMnn(this.lastAuctionId)
      
      this.loggingService.logFinish(_xid, 'App.Components.ModalMnnComponent.sort', null, 'Sort completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.ModalMnnComponent.sort', _error, null, 'Sort failed');
      throw _error;
    }
  }

  onFieldChange(){
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.ModalMnnComponent.onFieldChange', null, 'Field change started');
      
      this.filterMnn = $('#textMnnName').val().toString()
      this.loadMnn(this.lastAuctionId)
      
      this.loggingService.logFinish(_xid, 'App.Components.ModalMnnComponent.onFieldChange', null, 'Field change completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.ModalMnnComponent.onFieldChange', _error, null, 'Field change failed');
      throw _error;
    }
  }

  
  public loadMnn(IDAuction){
    const _xid = this.loggingService.generateUUID();
    this.loggingService.logStart(_xid, 'App.Components.ModalMnnComponent.loadMnn', null, 'Load MNN started');
    
    this.spinner.show();
    this.lastAuctionId = IDAuction
    this.dataMnn = new Array<MnnItem>();
    let mnnResponse: MnnResponse = {
      idAuction: IDAuction,
      filterMnn: this.filterMnn,
      sortColumnName: this.sortColumnName,
      sortColumnType: this.sortColumnType
    }

    this.http.post<Array<string>>(apiServer + "/mnn/info", mnnResponse, {})
    .subscribe(resp => { 
      for (let index = 0; index < resp.length; index++) {
        this.dataMnn[index] = { isGrotex: resp[index]['isGrotex'], mnnName: resp[index]['mnnName'], nmc: resp[index]['nmc'], persentage: resp[index]['persentage'], rowColor: resp[index]['rowColor'] }; 
      }
      this.lastSortColumnName = mnnResponse.sortColumnName
      this.spinner.hide()
      this.loggingService.logFinish(_xid, 'App.Components.ModalMnnComponent.loadMnn', null, 'Load MNN completed');
    }, error => {
      this.spinner.hide()
      this.loggingService.logError(_xid, 'App.Components.ModalMnnComponent.loadMnn', error, null, 'Load MNN failed');
    });

    this.updateSortIcons()
  }

  private updateSortIcons() {
    let colums = $.makeArray($('.sorted-colums'))
    colums.forEach(header => {
      header.classList.remove('asc', 'desc');
      header.classList.add('no-sort');
    });

    if (this.sortColumnName != null) {
      const currentHeaders = $.makeArray($(`#${this.sortColumnName}`))
      currentHeaders.forEach(el => {
        el.classList.remove('no-sort')
        el.classList.add(this.sortColumnType)
      })
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/home/components/home-main-modal-detail/modal-mnn/modal-mnn.component.ts